import { z } from "zod";

export const wishlistMetadata = z.object({
  totalItems: z.number().optional(),
  totalPages: z.number().optional(),
});

export type WishlistMetadata = z.infer<typeof wishlistMetadata>;
